<div class="blogs-approach-wrapper">

    <section class="blogs-wrapper">

        <div class="blogs-heading">Integration: HubSpot Blog Posts API 2</div>

        <div class="blogs-list">

            <div class="blog" *ngFor="let blog of blogs" [routerLink]="['/blogs', blog.id]">
                <div class="blog-image"><img src="{{blog.featuredImage}}" /></div>
                <div class="blog-name">{{ blog.name }}</div>
                <div class="blog-description" [innerHTML]="blog.blogDescription"></div>
                <div class="blog-cta">
                    <a [routerLink]="['/blogs', blog.id]">Read More</a>
                </div>
            </div>
        </div>

    </section>

</div>